import { useEffect, useState } from "react";
// import Image from "../../assets/images/DefaultProduct.png";
import Image from "../../assets/images/DefaultProduct.png";
import { IMAGE_BASE_URL } from "../../constants/constants";
import styles from "../../scss/common/common.module.scss";
import { Decrypt, imageOnError } from "../utils/Functions";
import { useSelector } from "react-redux";

interface IProps {
  product: any;
  changeQuantity: (productId: number, quantity: number) => void;
  checkoutPage?: boolean;
  bundleErros: number[];
  setBundleErros: any;
  editOptionValue?: (productId: number, optionId: number, type: any) => void;
}
const BundleItem = ({
  product,
  changeQuantity,
  checkoutPage = false,
  bundleErros,
  setBundleErros,
  editOptionValue,
}: IProps) => {
  const [productOptions, setProductOptions] = useState<any[]>([]);
  const storeData = useSelector((state: any) => state.storeDataSlice.data);
  // const cartDataInfo = localStorage?.getItem("cart");
  // const cartAllData = cartDataInfo ? JSON.parse(cartDataInfo) : [];
  const [productCartQty, setProductCartQty] = useState(0);
  // const [productCartQtyChange, setProductCartQtyChange] = useState(0);

  const [num, setNum] = useState(
    product.isSingleProduct
      ? product.quantity
      : product.store_product_detail.quantity
  );

  const [qtyError, setQtyError] = useState("");

  const addBundleError = () => {
    if (!bundleErros.includes(product.id)) {
      setBundleErros([...bundleErros, product.id]);
    }
  };

  const removeBundleError = () => {
    setBundleErros(bundleErros.filter((item) => item !== product.id));
  };

  const handleToggleEditMode = (
    productId: number,
    optionId: number,
    type: boolean
  ) => {
    const productOptionsCopy = [...productOptions];
    const currentOptionIndex = productOptionsCopy.findIndex(
      (item: any) => item.id === optionId && item.productId === productId
    );
    if (currentOptionIndex !== -1) {
      productOptionsCopy[currentOptionIndex].isEditing = type;
    } else {
      productOptionsCopy.push({
        id: optionId,
        productId: productId,
        isEditing: type,
      });
    }
    setProductOptions(productOptionsCopy);
  };
  let handleChange = (e: any) => {
    if (e.target.value === "") {
      setNum("");
      setQtyError(
        "Minimum Quantity allowed is " +
          (product.isSingleProduct
            ? product?.minimum_quantity ?? "1"
            : product?.store_product_detail.minimum_quantity ?? "1")
      );
      addBundleError();
    } else if (e.target.value < 1) {
      setQtyError(
        "Minimum Quantity allowed is " +
          (product.isSingleProduct
            ? product?.minimum_quantity ?? "1"
            : product?.store_product_detail.minimum_quantity ?? "1")
      );
    } else {
      let minUpdate = false;
      let maxUpdate = false;
      if (product.isSingleProduct) {
        if (product.minimum_quantity && product.minimum_quantity !== null) {
          if (e.target.value >= product.minimum_quantity) {
            minUpdate = true;
          } else {
            minUpdate = false;
            setQtyError(
              "Minimum Quantity allowed is " + product.minimum_quantity
            );
          }
        } else {
          if (e.target.value > 0) {
            minUpdate = true;
          } else {
            minUpdate = false;
            setQtyError("Minimum Quantity allowed is 1");
          }
        }
        if (product.maximum_quantity && product.maximum_quantity !== null) {
          if (
            Number(e.target.value) + Number(productCartQty) <=
            product.maximum_quantity
          ) {
            maxUpdate = true;
          } else {
            maxUpdate = false;
            setQtyError(
              "Maximum Quantity allowed is " + product.maximum_quantity
            );
          }
        } else {
          if (e.target.value > 0) {
            maxUpdate = true;
          }
          // if()
        }
      } else {
        if (
          product.store_product_detail.minimum_quantity &&
          product.store_product_detail.minimum_quantity !== null
        ) {
          if (e.target.value >= product.store_product_detail.minimum_quantity) {
            minUpdate = true;
          } else {
            minUpdate = false;
            setQtyError(
              "Minimum Quantity allowed is " +
                product.store_product_detail.minimum_quantity
            );
          }
        } else {
          if (e.target.value > 0) {
            minUpdate = true;
          } else {
            minUpdate = false;
            setQtyError("Minimum Quantity allowed is 1");
          }
        }
        if (
          product.store_product_detail.maximum_quantity &&
          product.store_product_detail.maximum_quantity !== null
        ) {
          if (
            Number(e.target.value) + Number(productCartQty) <=
            product.store_product_detail.maximum_quantity
          ) {
            maxUpdate = true;
          } else {
            maxUpdate = false;
            setQtyError(
              "Maximum Quantity allowed is " +
                product.store_product_detail.maximum_quantity
            );
          }
        } else {
          if (e.target.value > 0) {
            maxUpdate = true;
          }
        }
      }

      if (minUpdate && maxUpdate) {
        removeBundleError();
        setQtyError("");
      } else {
        addBundleError();
      }
      if (parseInt(e.target.value) <= 1000) {
        setNum(parseInt(e.target.value));
      }
    }
  };
  useEffect(() => {
    changeQuantity(product.id, num);
  }, [num]);
  useEffect(() => {
    // console.log(productOptions, "productOptions");
  }, [productOptions]);

  useEffect(() => {
    const cartDataInfoD = localStorage?.getItem("cart");
    const cartDataInfo = Decrypt(cartDataInfoD);
    const cartAllData = cartDataInfo ? JSON.parse(cartDataInfo) : [];
    if (product.isSingleProduct) {
      const cartItems = cartAllData.filter(
        (item: any) => item.id == product.id && item.isSingleProduct
      );

      let totalQty = 0;
      cartItems.map((item: any) => {
        if (item.cartItemId !== product.cartItemId) {
          totalQty += Number(item.quantity);
        }
      });

      setProductCartQty(totalQty);
    } else {
      const cartItems = cartAllData.find(
        (item: any) => item.id === product.bundle_id
      );

      if (cartItems) {
        const bundleProducts = cartItems.bundle_products;
        const cartBundleProducts = bundleProducts.filter(
          (item: any) => item.id == product.id
        );
        let totalQty = 0;
        cartBundleProducts.map((item: any) => {
          if (item.cartItemId !== product.cartItemId) {
            totalQty += Number(item.store_product_detail.quantity);
          }
        });

        setProductCartQty(totalQty);
      }
    }
    handleChange({
      target: {
        value: product.isSingleProduct
          ? product.quantity
          : product.store_product_detail.quantity,
      },
    });
  }, [product]);

  return (
    <div
      className={styles.itemModalCard}
      style={{ alignItems: checkoutPage ? "flex-start" : "center" }}
    >
      <div className={styles.itemModalContent}>
        <div className={styles.imgWrap}>
          <img
            loading="lazy"
            onError={(event) => imageOnError(event)}
            src={
              product.isSingleProduct
                ? product.store_product_images.length > 0
                  ? IMAGE_BASE_URL + product.store_product_images[0].image
                  : Image
                : product.store_product_detail.store_product_images.length > 0
                  ? IMAGE_BASE_URL +
                    product.store_product_detail.store_product_images[0].image
                  : Image
            }
            alt=""
          />
        </div>
        <div className={styles.itemModalHeading}>
          <h5>
            {product.isSingleProduct
              ? product.product_name
              : product.store_product_detail.product_name}
          </h5>

          {!product.isSingleProduct &&
            product.store_product_detail.store_options &&
            product.store_product_detail.store_options.length > 0 &&
            product.store_product_detail.store_options.map(
              (option: any, index: number) => {
                const item = option.store_option_items.filter(
                  (optionItem: any) => optionItem.id === option.selectedData
                );
                const currentOption = productOptions.find(
                  (item: any) =>
                    item.id === option.id && item.productId === product.id
                );

                return (
                  <p key={index} style={{ lineHeight: "18px",display: "flex", alignItems: "center", gap: "8px" }}>
                    {option.display_name}:{" "}
                    {option.option_type === 1 ? (
                      !checkoutPage ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          {currentOption?.isEditing ? (
                            <>
                              <select
                                defaultValue={option.selectedData}
                                onChange={(e) => {
                                  editOptionValue &&
                                    editOptionValue(
                                      product.id,
                                      option.id,
                                      Number(e.target.value)
                                    );
                                  // Update options state here
                                }}
                              >
                                {option.store_option_items.map((item: any) => (
                                  <option key={item.id} value={item.id}>
                                    {item.option_name}
                                  </option>
                                ))}
                              </select>
                              <button
                                style={{
                                  backgroundColor: "transparent",
                                  border: "1px solid #0F1729",
                                  cursor: "pointer",
                                  height: "20px",
                                  width: "20px",
                                  borderRadius: "4px",
                                }}
                                onClick={() => {
                                  handleToggleEditMode(
                                    product.id,
                                    option.id,
                                    false
                                  );
                                }}
                              >
                                <svg
                                  width="18px"
                                  height="18px"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M19.7071 6.29289C20.0976 6.68342 20.0976 7.31658 19.7071 7.70711L10.4142 17C9.63316 17.7811 8.36683 17.781 7.58579 17L3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929C3.68342 10.9024 4.31658 10.9024 4.70711 11.2929L9 15.5858L18.2929 6.29289C18.6834 5.90237 19.3166 5.90237 19.7071 6.29289Z"
                                    fill="#0F1729"
                                  />
                                </svg>
                              </button>
                            </>
                          ) : (
                            <>
                              <span>
                                {item.length > 0
                                  ? item[0].option_name
                                  : option.selectedData}
                              </span>
                              <button
                                style={{
                                  backgroundColor: "transparent",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  handleToggleEditMode(
                                    product.id,
                                    option.id,
                                    true
                                  );
                                  // Update options state here
                                }}
                              >
                                <svg
                                  width="20px"
                                  height="20px"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M21.2799 6.40005L11.7399 15.94C10.7899 16.89 7.96987 17.33 7.33987 16.7C6.70987 16.07 7.13987 13.25 8.08987 12.3L17.6399 2.75002C17.8754 2.49308 18.1605 2.28654 18.4781 2.14284C18.7956 1.99914 19.139 1.92124 19.4875 1.9139C19.8359 1.90657 20.1823 1.96991 20.5056 2.10012C20.8289 2.23033 21.1225 2.42473 21.3686 2.67153C21.6147 2.91833 21.8083 3.21243 21.9376 3.53609C22.0669 3.85976 22.1294 4.20626 22.1211 4.55471C22.1128 4.90316 22.0339 5.24635 21.8894 5.5635C21.7448 5.88065 21.5375 6.16524 21.2799 6.40005V6.40005Z"
                                    stroke="#000000"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M11 4H6C4.93913 4 3.92178 4.42142 3.17163 5.17157C2.42149 5.92172 2 6.93913 2 8V18C2 19.0609 2.42149 20.0783 3.17163 20.8284C3.92178 21.5786 4.93913 22 6 22H17C19.21 22 20 20.2 20 18V13"
                                    stroke="#000000"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </button>
                            </>
                          )}
                        </div>
                      ) : (
                        <span>
                          {item.length > 0
                            ? item[0].option_name
                            : option.selectedData}
                        </span>
                      )
                    ) : item.length > 0 ? (
                      item[0].option_name
                    ) : (
                      option.selectedData
                    )}
                    {/* {item.length > 0
                      ? item[0].option_name
                      : option.selectedData}{" "} */}
                  </p>
                );
              }
            )}

          {product.isSingleProduct &&
            product.store_options &&
            product.store_options.length > 0 &&
            product.store_options.map((option: any, index: number) => {
              const item = option.store_option_items.filter(
                (optionItem: any) => optionItem.id === option.selectedData
              );
              const currentOption = productOptions.find(
                (item: any) =>
                  item.id === option.id && item.productId === product.id
              );
              return (
                <p key={index} style={{ lineHeight: "18px",display: "flex", alignItems: "center", gap: "8px" }}>
                  {option.display_name}:
                  {option.option_type === 1 ? (
                    !checkoutPage ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      {currentOption?.isEditing ? (
                        <>
                          <select
                            defaultValue={option.selectedData}
                            onChange={(e) => {
                              editOptionValue &&
                                editOptionValue(
                                  product.id,
                                  option.id,
                                  Number(e.target.value)
                                );
                              // Update options state here
                            }}
                          >
                            {option.store_option_items.map((item: any) => (
                              <option key={item.id} value={item.id}>
                                {item.option_name}
                              </option>
                            ))}
                          </select>
                          <button
                            style={{
                              backgroundColor: "transparent",
                              border: "1px solid #0F1729",
                              cursor: "pointer",
                              height: "20px",
                              width: "20px",
                              borderRadius: "4px",
                            }}
                            onClick={() => {
                              handleToggleEditMode(
                                product.id,
                                option.id,
                                false
                              );
                            }}
                          >
                            <svg
                              width="18px"
                              height="18px"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M19.7071 6.29289C20.0976 6.68342 20.0976 7.31658 19.7071 7.70711L10.4142 17C9.63316 17.7811 8.36683 17.781 7.58579 17L3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929C3.68342 10.9024 4.31658 10.9024 4.70711 11.2929L9 15.5858L18.2929 6.29289C18.6834 5.90237 19.3166 5.90237 19.7071 6.29289Z"
                                fill="#0F1729"
                              />
                            </svg>
                          </button>
                        </>
                      ) : (
                        <>
                          <span>
                            {item.length > 0
                              ? item[0].option_name
                              : option.selectedData}
                          </span>
                          <button
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              handleToggleEditMode(product.id, option.id, true);
                              // Update options state here
                            }}
                          >
                            <svg
                              width="20px"
                              height="20px"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M21.2799 6.40005L11.7399 15.94C10.7899 16.89 7.96987 17.33 7.33987 16.7C6.70987 16.07 7.13987 13.25 8.08987 12.3L17.6399 2.75002C17.8754 2.49308 18.1605 2.28654 18.4781 2.14284C18.7956 1.99914 19.139 1.92124 19.4875 1.9139C19.8359 1.90657 20.1823 1.96991 20.5056 2.10012C20.8289 2.23033 21.1225 2.42473 21.3686 2.67153C21.6147 2.91833 21.8083 3.21243 21.9376 3.53609C22.0669 3.85976 22.1294 4.20626 22.1211 4.55471C22.1128 4.90316 22.0339 5.24635 21.8894 5.5635C21.7448 5.88065 21.5375 6.16524 21.2799 6.40005V6.40005Z"
                                stroke="#000000"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M11 4H6C4.93913 4 3.92178 4.42142 3.17163 5.17157C2.42149 5.92172 2 6.93913 2 8V18C2 19.0609 2.42149 20.0783 3.17163 20.8284C3.92178 21.5786 4.93913 22 6 22H17C19.21 22 20 20.2 20 18V13"
                                stroke="#000000"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </button>
                        </>
                      )}
                    </div>
                    ) : (
                      <span>
                        {item.length > 0
                          ? item[0].option_name
                          : option.selectedData}
                      </span>
                    )
                  ) : item.length > 0 ? (
                    item[0].option_name
                  ) : (
                    option.selectedData
                  )}
                </p>
              );
            })}
        </div>
      </div>
      <>
        <div className={styles.itemModalPrice}>
          {storeData.is_price_hide !== 1 &&
          storeData.payment_handle_type !== 2 ? (
            <span>
              $
              {product.isSingleProduct
                ? `${parseFloat((product.club_price * num).toString()).toFixed(
                    2
                  )}`
                : `${parseFloat(
                    (product.store_product_detail.club_price * num).toString()
                  ).toFixed(2)}`}
            </span>
          ) : (
            <span>{`$0.00`}</span>
          )}
          {!checkoutPage ? (
            <div className={styles.custom_incrementDecrement}>
              <div className={styles.input_group}>
                <div className={styles.input_group_prepend}>
                  <button
                    disabled={
                      num <=
                      (product.isSingleProduct
                        ? product?.minimum_quantity ?? 1
                        : product?.store_product_detail.minimum_quantity ?? 1)
                    }
                    className={styles.btn}
                    type="button"
                    onClick={() => handleChange({ target: { value: num - 1 } })}
                  >
                    -
                  </button>
                </div>
                <input
                  type="number"
                  className={styles.form_control}
                  value={num}
                  onChange={handleChange}
                />
                <div className={styles.input_group_prepend}>
                  <button
                    disabled={
                      num >=
                      (product.isSingleProduct
                        ? product?.maximum_quantity ?? 1000
                        : product?.store_product_detail?.maximum_quantity ??
                          1000)
                    }
                    className={styles.btn_outline}
                    type="button"
                    onClick={() => handleChange({ target: { value: num + 1 } })}
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <p>Qty : {num}</p>
          )}

          <p className={styles.errorMsg}>{qtyError}</p>
        </div>
      </>
    </div>
  );
};

export default BundleItem;
